// extracted by mini-css-extract-plugin
export var text = "_64-0";